
import { computed, inject, ref, watch } from '@vue/composition-api';
import LazyHydrate from 'vue-lazy-hydration';
import { Button, Modal, RangeInput } from '05-ui-kit';
import cloneDeep from 'lodash.clonedeep';
import debounce from 'lodash.debounce';
import isEqual from 'lodash.isequal';
import type { FilterGroup, FilterGroupCheckbox } from '~/type/Filter';
import type { EmitteryType } from '~/plugins/emitter';
import { useResizeStore } from '~/store/resize';
interface Props {
  show: boolean;
  showCount: number;
  loading: boolean;
  list: FilterGroup[];
  expandedGroupCount: number;
  value: {
    [key: string]: any;
  };
  showResetButton?: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  show: {
    key: "show",
    required: false,
    type: Boolean,
    default: false
  },
  showCount: {
    key: "showCount",
    required: false,
    type: Number,
    default: 5
  },
  loading: {
    key: "loading",
    required: false,
    type: Boolean,
    default: false
  },
  list: {
    key: "list",
    required: true,
    type: Array
  },
  expandedGroupCount: {
    key: "expandedGroupCount",
    required: false,
    type: Number,
    default: 4
  },
  value: {
    key: "value",
    required: true,
    type: Object
  },
  showResetButton: {
    key: "showResetButton",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const emitter = inject<EmitteryType>('emitter')!;
  const innerValue = ref(cloneDeep(props.value));
  const filterActive = ref<FilterGroupCheckbox>();
  const resizeStore = useResizeStore();
  const notMobile = computed(() => resizeStore.resize && resizeStore.resize > 900);
  const debounceChange = debounce(onChangeRangeInput, 300);
  const modal = ref();
  const count = computed(() => {
    return Object.keys(innerValue.value)?.length || 0;
  });
  function onChangeRangeInput(property: string, oldValue: string, newValue: string) {
    // Дополнительная проверка нужна для сравнения значений null и 0 как идентичных
    if (oldValue !== newValue && (oldValue === null || newValue === null ? !!oldValue !== !!newValue : true)) {
      change({
        property,
        value: newValue
      });
    }
  }
  function change({
    property,
    value
  }: {
    property?: string;
    value?: string;
  }) {
    if (!value && property && property in innerValue.value) {
      const updatedValue = {
        ...innerValue.value
      };
      delete updatedValue[property];
      innerValue.value = updatedValue;
    } else if (property) {
      innerValue.value = {
        ...innerValue.value,
        [property]: value
      };
    }
    checkZeroPrice();
    if (!filterActive.value) emit('submit', cloneDeep(innerValue.value));
  }
  function onCheckboxFilterClick(group: FilterGroupCheckbox) {
    filterActive.value = group;
    modal.value.$el.scroll(0, 0);
    emitter.emit('click-filter-arrow-property');
  }
  function submit() {
    checkZeroPrice();
    /**
    * Срабатывает при применении фильтров в мобильной версии на 2 уровне
    */
    if (filterActive.value && !isEqual(innerValue.value, props.value)) emit('submit', cloneDeep(innerValue.value));
    filterActive.value = undefined;
  }
  function checkZeroPrice() {
    /*
    * Если при изменении Range фильтра с бэка приходит нулевая цена, то не добавляем её в запросы
    */
    if (innerValue.value.price_to === 0) delete innerValue.value.price_to;
    if (innerValue.value.price_from === 0) delete innerValue.value.price_from;
  }
  function reset() {
    /**
    * Сброс фильтров
    */
    innerValue.value = {};
    emit('submit', {});
  }
  watch(() => props.value, value => {
    innerValue.value = value;
  }, {
    deep: true
  });
  watch(() => props.show, state => {
    innerValue.value = state ? cloneDeep(props.value) : innerValue.value;
  });
  return Object.assign({
    emit,
    innerValue,
    filterActive,
    notMobile,
    debounceChange,
    modal,
    count,
    change,
    onCheckboxFilterClick,
    submit,
    reset
  }, {
    count
  });
};
__sfc_main.components = Object.assign({
  LazyHydrate,
  Modal,
  RangeInput,
  Button
}, __sfc_main.components);
export default __sfc_main;
